var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLol = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6.488 8.82V4.9a13.44 13.44 0 0 0 0 21.67v-4.08a10.86 10.86 0 0 1 0-13.67z",
  fill: "#C89B3C"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.408 1.02v24.64h15.19l-3.39 4.78h-21l2.53-3V4l-2.53-3 9.2.02z",
  fill: "#C89B3C"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M27.348 15.64a10.7 10.7 0 0 1-4.63 8.72h4.55a13.35 13.35 0 0 0 3.16-8.6c0-7.69-6.58-13.92-14.71-13.92v2.87c6.42 0 11.63 4.89 11.63 10.93z",
  fill: "#C89B3C"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M20.718 24.33a9.9 9.9 0 0 0 5.42-8.7c0-5.44-4.62-9.85-10.37-10V24.3l4.95.03zM6.488 11.12a9.5 9.5 0 0 0-1.15 4.51 9.35 9.35 0 0 0 1.15 4.48v-8.99z",
  fill: "#16B4CC"
})));
export default SvgLol;